module.exports = __webpack_public_path__ + "static/media/arrGrey.f8749ca6.svg";